package sarka.design.skoria.webrtc

import kotlinx.serialization.Serializable

@Serializable
data class SdpPayload(
    val type: String, // "offer" | "answer"
    val sdp: String
)

@Serializable
data class IceCandidatePayload(
    val candidate: String,
    val sdpMid: String,
    val sdpMLineIndex: Int
)

@Serializable
sealed class SignalEnvelope {
    abstract val kind: String

    @Serializable
    data class RtcSdp(
        override val kind: String = "RTC_SDP",
        val payload: SdpPayload
    ) : SignalEnvelope()

    @Serializable
    data class RtcIce(
        override val kind: String = "RTC_ICE",
        val payload: IceCandidatePayload
    ) : SignalEnvelope()
}